import * as React from 'react';
import {
  Box,
  HeadingText,
  ParagraphText,
  StackLayout,
  ImageMessage,
  Button,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { handleStaticAsset } from '@leagueplatform/asset-config';
import { LegacyOrderNewCardAnalyticsData } from '#types/analytics.types.ts';
import { BENEFIT_SCREEN_NAMES } from '../constants/analytics-benefit-property-names';
import { useWalletDetailScreenLoaded } from '../hooks/use-wallet-detail-analytics.hook';
import { LEGACY_ORDER_NEW_CARD_MODULE_ASSET_KEYS } from '../asset-map';

export interface EndScreenProps {
  onClick: () => void;
  status: 'success' | 'error' | 'idle' | 'loading';
  analyticsData: LegacyOrderNewCardAnalyticsData;
}

export const EndScreen = React.forwardRef<HTMLDivElement, EndScreenProps>(
  ({ onClick, status, analyticsData }, ref) => {
    const isSuccess = status === 'success';
    const isLoading = status === 'loading';
    const { formatMessage } = useIntl();
    const SUCCESS_IMAGE = handleStaticAsset(
      LEGACY_ORDER_NEW_CARD_MODULE_ASSET_KEYS.ORDER_NEW_CARD_SUCCESS,
    ) as string;
    const ERROR_IMAGE = handleStaticAsset(
      LEGACY_ORDER_NEW_CARD_MODULE_ASSET_KEYS.ORDER_NEW_CARD_ERROR,
    ) as string;

    const logScreenLoaded = useWalletDetailScreenLoaded;
    if (isSuccess) {
      logScreenLoaded(
        BENEFIT_SCREEN_NAMES.ORDER_NEW_CARD_SUCCESS,
        analyticsData,
      );
    }

    return (
      <Box css={{ padding: '$none $two' }} ref={ref}>
        <ImageMessage
          image={isSuccess ? SUCCESS_IMAGE : ERROR_IMAGE}
          imageGap="$twoAndHalf"
        >
          <StackLayout horizontalAlignment="center" spacing="$half">
            <HeadingText level="3" size="lg">
              {isSuccess
                ? formatMessage({ id: 'SUCCESS' })
                : formatMessage({ id: 'ERROR_STATE_TITLE' })}
            </HeadingText>

            <ParagraphText>
              <ParagraphText
                as="span"
                css={{ display: 'block', textAlign: 'center' }}
              >
                {isSuccess
                  ? formatMessage({ id: 'MEMBER_CARD_ON_ITS_WAY' })
                  : formatMessage({ id: 'ERROR_HEADING' })}
              </ParagraphText>
              <ParagraphText
                as="span"
                css={{ display: 'block', textAlign: 'center' }}
              >
                {isSuccess
                  ? formatMessage({ id: 'MEMBER_CARD_ARRIVAL' })
                  : formatMessage({ id: 'TRY_LATER' })}
              </ParagraphText>
            </ParagraphText>

            <Button
              onClick={onClick}
              width="fillContainer"
              css={{ marginTop: '$twoAndHalf' }}
              loading={isLoading}
              disabled={isLoading}
            >
              {isSuccess
                ? formatMessage({ id: 'CLOSE' })
                : formatMessage({ id: 'RESUBMIT' })}
            </Button>
          </StackLayout>
        </ImageMessage>
      </Box>
    );
  },
);
